import { useTranslation } from "react-i18next";
import { SvgIcon, IconButton, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { usePopover } from "@hooks/shared/use-popover";
import { AccountPopover } from "@components/shared/elements/account-popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/pro-light-svg-icons";

export const AccountButton = () => {
  const popover = usePopover();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={t("client.profile")}>
        <IconButton
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          data-testid="account-button"
          sx={{
            backgroundColor: popover.open
              ? alpha(theme.palette.text.primary, 0.1)
              : "transparent",
            color: popover.open ? theme.palette.text.primary : undefined,
          }}
        >
          <SvgIcon>
            <FontAwesomeIcon icon={faCircleUser} />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
